import { render } from "./SandboxHome.vue?vue&type=template&id=2cf1735e&scoped=true"
import script from "./SandboxHome.vue?vue&type=script&lang=js"
export * from "./SandboxHome.vue?vue&type=script&lang=js"

import "./SandboxHome.vue?vue&type=style&index=0&id=2cf1735e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf1735e"]])

export default __exports__